import { useEffect, useMemo, useState } from "react";
import { ISessionWithBookings } from "../../interfaces/Session";
import {
  getDriverCount,
  getGradientColor
} from "../../pages/dashboard/utilities";
import { TBookingType } from "../../interfaces";
import { PercentageSlider } from "./PercentageSlider";
import { getMaxNumberOfSession } from "../../utilities";

const BookingDriverSeats = ({ session, view }: BookingDriverSeatsProps) => {
  const [totalDrivers, setTotalDrivers] = useState(0);
  const [bookedPercentage, setBookedPercentage] = useState(0);
  const seatsSoldColour = useMemo(() => getGradientColor("#00FFFF", "#FF00FF", bookedPercentage), [bookedPercentage]);

  useEffect(() => {
    let total = 0;
    session.bookings.forEach((x) => {
      const bookingDriverCount = getDriverCount(x);
      total += bookingDriverCount;
    });
    setTotalDrivers(total);

    const totalNumberOfSeats = getMaxNumberOfSession(view);
    
    const percentage = (total / totalNumberOfSeats) * 100;
    setBookedPercentage(percentage);
  }, [session, view]);

  return <PercentageSlider percentage={bookedPercentage} backgroundColour={seatsSoldColour} count={totalDrivers} bookings={session.bookings} />;
};

interface BookingDriverSeatsProps {
  session: ISessionWithBookings;
  view: TBookingType;
}

export default BookingDriverSeats;
